(function () {
  'use strict';

  // Mobile nav
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product: variant select -> price + availability
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    var button = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-product-price]');
    if (!select) return;

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
      if (button) {
        var available = opt.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
      }
    });
  });

  // Product: thumbnail swap
  var mainImage = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.dataset.full || thumb.src;
    });
  });
})();

// Testimonial carousel arrows
(function () {
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var step = function () {
      var card = track.querySelector('.revcard');
      return card ? card.offsetWidth + 18 : track.clientWidth * 0.8;
    };
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();

// Quantity stepper
(function () {
  document.querySelectorAll('[data-qty-input]').forEach(function (input) {
    var form = input.closest('form') || document;
    var dec = form.querySelector('[data-qty-down]');
    var inc = form.querySelector('[data-qty-up]');
    var set = function (n) { input.value = Math.max(1, n); };
    if (dec) dec.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
  });
})();

// Pack radio -> price + button state + sticky bar price
(function () {
  var button = document.querySelector('[data-add-button]');
  var priceEl = document.querySelector('[data-product-price]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var radios = document.querySelectorAll('[data-variant-radio]');
  if (!radios.length) return;

  function sync(radio) {
    if (priceEl) {
      priceEl.innerHTML = radio.dataset.price +
        (radio.dataset.compare ? ' <s>' + radio.dataset.compare + '</s>' : '');
    }
    if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
    if (button) {
      var ok = radio.dataset.available === 'true';
      button.disabled = !ok;
      button.textContent = ok ? button.dataset.labelAdd : button.dataset.labelSoldOut;
    }
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () { if (radio.checked) sync(radio); });
    if (radio.checked) sync(radio);
  });
})();

// Gallery thumbnails
(function () {
  var main = document.querySelector('[data-main-image]');
  var thumbs = document.querySelectorAll('[data-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      main.src = thumb.dataset.full;
      thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
    });
  });
  thumbs[0].setAttribute('aria-current', 'true');
})();

// Sticky add-to-cart bar: show once the buy box has scrolled past
(function () {
  var bar = document.querySelector('[data-sticky-bar]');
  var buybox = document.getElementById('buy');
  if (!bar || !buybox || !('IntersectionObserver' in window)) return;

  var cta = bar.querySelector('[data-sticky-cta]');
  if (cta) {
    cta.addEventListener('click', function (event) {
      event.preventDefault();
      buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    });
  }, { rootMargin: '-120px 0px 0px 0px' }).observe(buybox);
})();
